import React from 'react';
import { Collapse as MUICollapse } from '@mui/material';
export const Collapse = props => /*#__PURE__*/React.createElement(MUICollapse, props);
export default Collapse;